// Which notification's Details are open (ART-327/328) — the `pendingInvitesPanel.ts` shape.
//
// The bell's dropdown dismisses on any pointerdown outside itself, and a Details pop-up is portalled to <body> — so
// one rendered INSIDE the dropdown was unmounted by the first click on it (the dropdown closed and took it along).
// The Details are therefore mounted ONCE at the router root (`NotificationDetailsHost`) and opened through this
// store. UI state only.
import { create } from "zustand";
import type { NotificationRow } from "./hooks/useNotifications.js";
import { registerStoreReset } from "./stores.js";

export type NotificationDetailsTarget =
  | { row: NotificationRow; kind: "opportunity"; id: string }
  | { row: NotificationRow; kind: "request"; offerId: string };

interface NotificationDetailsPanelState {
  target: NotificationDetailsTarget | null;
  show: (target: NotificationDetailsTarget) => void;
  hide: () => void;
  reset: () => void;
}

export const useNotificationDetailsPanel = create<NotificationDetailsPanelState>((set) => ({
  target: null,
  show: (target) => set({ target }),
  hide: () => set({ target: null }),
  reset: () => set({ target: null }),
}));

// Scorch on band switch + logout — never paint one tenant's Details over the next.
registerStoreReset(() => useNotificationDetailsPanel.getState().reset());
